<template>
  <main>
    <tab-header />
    <div class="tab-content" :class="{'section-loading': dataLoading}">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        轄下異動後實質接觸明細
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">受撥月份</label>
                            <div class="col-11">
                                <select class="form-control form-control-inline ml-0" v-model="form.startYear">
                                    <option :value="item.value" v-for="(item, index) in yearOpt" :key="`S-year-${index}`">
                                      {{ item.title }}
                                    </option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.startMonth">
                                    <option :value="month.value" v-for="(month, index) in monthOpt" :key="`S-month-${index}`">
                                      {{ month.title }}
                                    </option>
                                </select>
                                <span class="text">～</span>
                                <select class="form-control form-control-inline" v-model="form.endYear">
                                    <option :value="item.value" v-for="(item, index) in yearOpt" :key="`S-year-${index}`">
                                      {{ item.title }}
                                    </option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.endMonth">
                                    <option :value="month.value" v-for="(month, index) in monthOpt" :key="`S-month-${index}`">
                                      {{ month.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-1 text-right">服務人員</label>
                            <div class="col-3">
                                <select v-model="id_no" class="form-control" alt="ch">
                                    <option value="">全部</option>
                                    <option :value="person.clcid+','+person.div_no" v-for="(person, index) in peopleList" :key="`people-${index}`">
                                      {{person.div_no}} {{ person.clcid_nm }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-11 offset-1">
                                <div class="float-right pt-3">
                                    <!--<a href="#" class="link text-underline">
                                        保戶拜訪SOP(含未訪件說明)
                                    </a>-->
                                </div>
                                <a @click="clickSearch = true;searchData()" class="btn btn-primary ml-0">查詢</a>
                            </div>
                        </div>
                        <div>
                          <span>
                            ＊未實質接觸({{ idfin_count1 }}位要保人，{{ plfin_count1 }}張保單)  ＊已實質接觸({{ idfin_count2 }}位要保人，{{ plfin_count2 }}張保單)
                          </span>
                        </div>
                        <br>
                    </form>
                </div>
                <div class="col-12">
                <tab52-table
                  :table-data="tableRow"
                  :click-Search ="clickSearch"
                />
                </div>
            </div>
        </div>
      </div>
    </div>

    <connect-data-modal
    :open="connectModalOpen"
    :detailData="detailData"
    @close="panelClose('connectModalOpen')"/>
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import ConnectDataModal from '@/desktop/components/manager/ConnectData'
import Tab52Table from '../manager/condition/components/Tab52Table'
import { debuglog } from 'util';
import { getChangePeople, getChangeDetail, queryBelowEstrangePolicyContactInfo } from '@/service'

export default {
  name: 'TransferTab52',
  mixins: [commonMixin],
  components: {
    TabHeader, ConnectDataModal,Tab52Table
  },
  computed: {
    ...mapGetters([
      
    ]),
    startDate () {  // 計算開始日期
      return `${this.form.startYear}-${this.form.startMonth}-01`
    },
    endDate () {  // 計算結束日期
      let lastDay = new Date(this.form.endYear,this.form.endMonth,0).getDate() + ''
      return `${this.form.endYear}-${this.form.endMonth}-${lastDay.length == 1 ? '0' + lastDay : lastDay}`
    },
  },
  data () {
    return {
      agDivNo: '',
      clcno_lv: '',
      peopleList: [],
      yearOpt: [],
      tableRow: [],
      detailData: {},
      dataLoading: false,
      clickSearch: false,
      idfin_count1:"0",
      idfin_count2:"0",
      plfin_count1:"0",
      plfin_count2:"0",
      monthOpt:[
        {title: '1 月', value: '01'},
        {title: '2 月', value: '02'},
        {title: '3 月', value: '03'},
        {title: '4 月', value: '04'},
        {title: '5 月', value: '05'},
        {title: '6 月', value: '06'},
        {title: '7 月', value: '07'},
        {title: '8 月', value: '08'},
        {title: '9 月', value: '09'},
        {title: '10 月', value: '10'},
        {title: '11 月', value: '11'},
        {title: '12 月', value: '12'},
      ],
      selection: {
        clcno: '', // 收費代號
        clcid: '', // 收費人員ID
      },
      id_no:'',
      connectModalOpen: false,
      order: {
        index: 1,
        asc: true
      },
      form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      currentRowID: 0,
    }
  },
  watch: {
    'id_no' : function(val) {  // 收費人員ID 同步 收費代號
      if(val == ''){ this.selection.clcno = '' }
      else{
        let sel = val.split(",")
        this.selection.clcid = sel[0]
        this.selection.clcno = sel[1]
      }
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    initChangeDetail () {  // 初始化
      // 取得轄下異動後實質接觸 下拉人員
      this.dataLoading = true
      getChangePeople(this.$store.state.userInfo.id, this.clcno_lv).then(result => {
        this.dataLoading = false
        if (result.header && "200" == result.header.status) {
          this.peopleList = result.body.clcno_agnts
        }
        this.registerHanlink()
      })
    },
    searchData () {
      // 轄下異動後實質接觸明細
      this.dataLoading = true
      getChangeDetail(this.$store.state.userInfo.id, this.agDivNo, this.clcno_lv, this.startDate, this.endDate, this.selection.clcid, '0').then(result => { 
        this.dataLoading = false
        if (result.header && "200" == result.header.status) {
          this.tableRow = result.body.notice_list
          result.body.total_list.map(item => {
              this.idfin_count1 = item.idfin_count1 ? item.idfin_count1 : "0";
              this.idfin_count2 = item.idfin_count2 ? item.idfin_count2 : "0";
              this.plfin_count1 = item.plfin_count1 ? item.plfin_count1 : "0";
              this.plfin_count2 = item.plfin_count2 ? item.plfin_count2 : "0";
          });
        }
        this.registerHanlink()
      })
    },
    searchConnectInfoDetail(ceapcno, ceapcnm){ //實質接觸排除整合地址查詢
      this.detailData = {}
      this.dataLoading = true
      queryBelowEstrangePolicyContactInfo(this.$store.state.userInfo.id, ceapcno, ceapcnm).then(result=>{
        this.dataLoading = false
        if(result.header && result.header.status === '200') {
          this.detailData = result.body.detail
          this.registerHanlink()
          this.panelOpen('connectModalOpen') 
        } else {
          this.detailData = {}
        }
      })
    },
    columnSorting(i, key) {
      if (this.order.index == i) {
        this.order.asc = !this.order.asc
        if(this.order.asc) {
          this.tableRow = this.tableRow.sort((A, B) => {
            return A[key] > B[key] ? 1 : -1
          })
        }else{
          this.tableRow = this.tableRow.sort((A, B) => {
            return A[key] <= B[key] ? 1 : -1
          })
        }
      } else {
        this.order.asc = true
        this.tableRow = this.tableRow.sort((A, B) => {
          return A[key] > B[key] ? 1 : -1
        })
      }
      this.order.index = i
      
      // for 難字 update
      let cacheList = [...this.tableRow]
      this.tableRow = []
      setTimeout(() => {
        this.tableRow = cacheList
        this.registerHanlink()
      }, 200)
    },
    initDate () {  // 初始化日期
      let nowDate = this.getCurrentDate().split('-')
      //  產生年份 select
      let endY = nowDate[0] - 1911 
      for (let i = 103;i <= endY;i++) {
        this.yearOpt.push({title: `${i} 年`, value: i + 1911 + ''})
      }

      //  初始化結束日期
      this.form.endYear = nowDate[0]
      this.form.endMonth = nowDate[1].length == 1? '0' + nowDate[1] : nowDate[1]
      
      //  初始化開始日期
      if(nowDate[1] - 1 > 0) {
        this.form.startYear = nowDate[0]
        this.form.startMonth = (nowDate[1] - 1 + '').length == 1 ? '0' + (nowDate[1] - 1 + '') : (nowDate[1] - 1 + '')
      } else {
        this.form.startYear = nowDate[0] - 1 + ''
        this.form.startMonth = (nowDate[1] - 1 + 12 + '').length == 1 ? '0' + (nowDate[1] - 1 + 12 + '') : (nowDate[1] - 1 + 12 + '')
      } 
      
    },
    initDivNoAndClcno() {
      this.agDivNo = this.$store.state.userInfo.divNo.substr(0,3)
      let clcno = this.$store.state.userInfo.divNo
      if(this.$store.state.userInfo.divNo.substr(2, 1) == '4') {
        clcno = this.$store.state.userInfo.divNo.substr(0,2) + '5' + this.$store.state.userInfo.divNo.substr(3,5)
      }
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_02':
        case 'SALES_MANAGER_05':
          this.clcno_lv = clcno.substr(0, 3)
          break;
        case 'SALES_MANAGER_06':
          if(this.$store.state.userInfo.userCategoryId =='A019'){
            this.clcno_lv = clcno.substr(0, 3)
            break;
          }else if(this.$store.state.userInfo.userCategoryId =='A044'){
            this.clcno_lv = clcno.substr(0, 4)
            break;
          }
          else{
            this.clcno_lv = clcno.substr(0, 5)
            break;
          }
        case 'SALES_MANAGER_03':
          this.clcno_lv = clcno.substr(0, 4)
          break;
        case 'SALES_MANAGER_04':
          this.clcno_lv = clcno.substr(0, 5)
          break;
      }
    },
  },
  mounted () {
    //  設定 單位代號 前三碼
    this.initDivNoAndClcno()

    // 初始化日期
    this.initDate()
    
    // 初始化資料
    this.initChangeDetail()
  }
}
</script>
